import { isIterable } from "lib/actions/util";
import { useImperativeHandle, useRef } from "react";

export type FileBrowserInterface = {
  open: () => void;
};

export default function FileBrowser({
  ref,
  ...p
}: {
  multi?: boolean;
  onSelected: (files: File[]) => void;
  accept?: Iterable<string> | string;
} & {
  ref: React.RefObject<FileBrowserInterface>;
}) {
  const multi = p.multi ?? false;
  const inputRef = useRef<HTMLInputElement>(null);

  const accept =
    typeof p.accept === "string"
      ? p.accept
      : isIterable(p.accept)
        ? Array.from(p.accept, (ext) => `.${ext}`).join(",")
        : null;

  //extend component interface with this object
  useImperativeHandle(
    ref,
    () => ({
      open: () => {
        inputRef.current?.click();
      },
    }),
    [inputRef],
  );

  const onChange = (ev) => {
    let files = Array.from<File>(ev.target.files);
    p.onSelected && p.onSelected(files);
    inputRef.current.value = null;
  };

  return (
    <input
      ref={inputRef}
      type="file"
      {...(multi && { multiple: true })}
      accept={accept}
      className="hidden"
      onChange={onChange}
    />
  );
}
